import React from "react";
import { UpgradeMembershipModalProps } from "../UpgradeMembershipModal/UpgradeMembershipModal";
import { ProductHeading } from "../UpgradeMembershipModal/components/ProductHeading";
import { TermsCheckbox } from "../TermsCheckbox";
import styles from "./TermsAndConditions.module.scss";

export type TermsAndConditionsProps = {
  onChangeTermsCheckbox: (isChecked: boolean) => void;
  hasTrainerGrants: boolean;
  termDocumentUrl: string;
} & Pick<UpgradeMembershipModalProps, "productName" | "productPrice">;

const TermsAndConditions = ({
  productName,
  productPrice,
  onChangeTermsCheckbox,
  hasTrainerGrants,
  termDocumentUrl,
}: TermsAndConditionsProps) => {
  const productHeadingProps = {
    productName: hasTrainerGrants ? undefined : productName,
    productPrice: hasTrainerGrants ? undefined : productPrice,
    subTitle: "PLEASE REVIEW WITH MEMBER",
  };
  return (
    <>
      <ProductHeading {...productHeadingProps} />
      <div className={styles.innerContent}>
        <div className={styles.terms}>
          <iframe
            src={termDocumentUrl}
            width="100%"
            height="400"
            className={styles.iframe}
            title="Terms and Conditions"
          />
        </div>
        <TermsCheckbox
          onChangeTermsCheckbox={onChangeTermsCheckbox}
          hasTrainerGrants={hasTrainerGrants}
        />
      </div>
    </>
  );
};

export default TermsAndConditions;
